import { render } from "./Index_en_m.vue?vue&type=template&id=028254ba"
import script from "./Index_en_m.vue?vue&type=script&lang=js"
export * from "./Index_en_m.vue?vue&type=script&lang=js"

import "./Index_en_m.vue?vue&type=style&index=0&id=028254ba&lang=css"
script.render = render

export default script